module.exports = __webpack_public_path__ + "media/images/img-rafeni-f52ba857ca8da9d6f66ac8c4dd42f50d.png";